import { render } from "./ShippingInfo.vue?vue&type=template&id=b2b372d2&scoped=true"
import script from "./ShippingInfo.vue?vue&type=script&lang=ts"
export * from "./ShippingInfo.vue?vue&type=script&lang=ts"

import "./ShippingInfo.vue?vue&type=style&index=0&id=b2b372d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b2b372d2"

export default script